import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/form/Button';
import SectionContainer from 'components/Containers/SectionContainer';
import Label from 'components/form/Label/Label';
import 'components/Offers/CreditRepairRedesign/CreditRepairOfferRedesign.scss';
import classnames from 'classnames';
import { PrefillTooltip } from 'components/Offers/fragments/PrefillTooltip/PrefillTooltip';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import BulletList from 'components/BulletList/BulletList';
import Bullet from 'components/BulletList/Bullet';
import { useConfig } from 'hook/config.hook';

const CreditRepairBullets = ({ bullets }) => {
  return (
    <BulletList paddingLeftClass="margR16">
      {bullets?.map((bullet, index) => {
        return (
          <Bullet
            key={index}
            className="caption"
            datatestid={`creditRepairOffer-bulletItem-${index}`}
          >
            {bullet}
          </Bullet>
        );
      })}
    </BulletList>
  );
};

const CreditRepairImage = ({ imageLink, datatestid }) => {
  return (
    <FlexContainer
      data-testid={
        datatestid
          ? `${datatestid}-creditRepairOfferImage`
          : 'creditRepairOfferImage'
      }
      className="margB16 "
    >
      <img src={imageLink} alt="credit repair"></img>
    </FlexContainer>
  );
};

const CreditRepairApplySection = ({
  buttonLabel,
  clickApplyHandler,
  prepopulateTooltipClass,
  applySectionClass,
  datatestid,
  isOcf,
}) => {
  const ocfCheckOptions = classnames('button', {
    'ocfChckBtn m-margLRAuto': isOcf,
  });
  const { config } = useConfig();
  return (
    <FlexContainer className={applySectionClass}>
      <Button
        mrphType="primary"
        onClick={clickApplyHandler}
        datatestid="creditRepairOfferApply"
        className={ocfCheckOptions}
      >
        <Label data-testid="creditRepairOfferApplyNumber">{buttonLabel}</Label>
      </Button>
      <FlexContainer className="padB12" />
      {!isOcf && (
        <FlexContainer className={prepopulateTooltipClass}>
          <PrefillTooltip
            type="consultation form"
            title={config?.disclaimers?.lexLawPrefillTooltip}
            datatestid={datatestid}
          />
        </FlexContainer>
      )}
    </FlexContainer>
  );
};

const CreditRepairOfferRedesign = props => {
  const sectionTypeClass = classnames(
    'creditRepairOfferRedesignContainer border-rad8px width100',
    {
      columnViewWidth: props.columnView,
    },
  );

  const containerTypeClass = classnames(
    'mobile-justify-center',
    'tablet-align-items-auto',
    'flex-tablet-col',
    'flex-column',
    'items-align-center',
    {
      block: props.columnView,
    },
  );

  const applySectionClass = classnames(
    'creditRepairApplyButton',
    'tabletWidth100',
    'flex-column',
    'items-align-center',
    {
      format100: props.columnView,
    },
  );

  const prepopulateTooltipClass = classnames('mobile-justify-center tooltip', {
    'justify-center': props.columnView,
    'justify-end': !props.columnView,
  });

  const isOcf = props.extraProps ? props.extraProps.isOcf : false;

  return (
    <SectionContainer
      datatestid="creditRepairOffer"
      type="creditRepairOfferCard"
      className={sectionTypeClass}
    >
      <FlexContainer className={containerTypeClass}>
        {props.seenPixel}
        <CreditRepairImage
          datatestid={props.datatestid}
          imageLink={props?.offerImageLinkUrlProxy}
        />
        <FlexContainer>
          <CreditRepairBullets bullets={props.bullets} />
        </FlexContainer>
        <CreditRepairApplySection
          buttonLabel={props.buttonLabel}
          clickApplyHandler={props.clickApplyHandler}
          prepopulateTooltipClass={prepopulateTooltipClass}
          applySectionClass={applySectionClass}
          datatestid={props.datatestid}
          isOcf={isOcf}
        />
      </FlexContainer>
    </SectionContainer>
  );
};

CreditRepairOfferRedesign.propTypes = {
  offerMetadata: PropTypes.shape({
    bullets: PropTypes.array,
    imageLink: PropTypes.string,
    phone: PropTypes.string,
    callNowMessage: PropTypes.string,
    linkUrl: PropTypes.string,
  }),
  clickApplyHandler: PropTypes.func,
};

export default CreditRepairOfferRedesign;
